import {
  assign, endpoint, options, check, convert,
} from '../helpers';
import { Report as action } from '../../redux/actions';

/**
 * Creates a new report
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const reports = (properties) => {
  const props = assign(properties);
  const model = {
    Report: props.data.report,
    Configuration: props.data.configuration.rules.map(item => ({
      Column: item.cell,
      Row: item.row,
      TableAddress: item.formula ? `$${item.formula}` : `${props.data.configuration.table}$${item.column}`,
    })),
    Template: props.data.template,
  };

  fetch(endpoint('/save-report'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        if (props.dispatch) {
          props.dispatch(action.create({
            Configuration: model.Configuration,
            Name: model.Report,
            Template: model.Template,
          }));
        }
        props.success(convert(response.Message));
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default reports;
